import { useContext } from 'react';
import { CurrentUserContext } from '../context/current-user';

/**
 * A hook to get details about the current user from the CurrentUserContext.
 *
 * @returns A tuple containing:
 * 1. The current user details, or null if still loading/no logged-in user;
 * 2. A boolean loading state to indicate whether the user details are being fetched.
 */
const useCurrentUser = () => {
  const context = useContext(CurrentUserContext);

  if (context === undefined) {
    throw new Error('Could not find the current user context. Please wrap your code with the <CurrentUserProvider />.');
  }

  return context;
};

export default useCurrentUser;
